import { render, staticRenderFns } from "./PortfolioSelectWrapper.vue?vue&type=template&id=20e4e414&scoped=true&"
import script from "./PortfolioSelectWrapper.vue?vue&type=script&lang=js&"
export * from "./PortfolioSelectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4e414",
  null
  
)

export default component.exports